// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Lv-z","tooltipWrapper":"Mv-z","icon":"Nv-z","tooltip":"Ov-z","content":"Pv-z"};